import React from "react";
import { Box, Stack, Typography } from "@mui/material";

/**
 * Cabecera de página: título (h1), subtítulo, ícono y acciones.
 * En pantallas pequeñas las acciones pasan debajo del título.
 *
 * @param {object} props
 * @param {React.ReactNode} props.titulo
 * @param {React.ReactNode} [props.subtitulo]
 * @param {React.ReactNode} [props.icono] Elemento de ícono (decorativo).
 * @param {React.ReactNode} [props.acciones] Botones u otros controles, a la derecha.
 * @param {string} [props.variante] Variante tipográfica del título (por defecto "h5").
 */
export const PageHeader = ({
  titulo,
  subtitulo,
  icono,
  acciones,
  variante = "h5",
}) => (
  <Stack
    direction={{ xs: "column", sm: "row" }}
    spacing={2}
    justifyContent="space-between"
    alignItems={{ xs: "stretch", sm: "center" }}
    sx={{ mb: 3 }}
  >
    <Stack
      direction="row"
      spacing={1.5}
      alignItems="center"
      sx={{ minWidth: 0 }}
    >
      {icono && (
        <Box
          aria-hidden="true"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
            width: 44,
            height: 44,
            borderRadius: 1,
            bgcolor: (theme) => theme.palette.soft?.primary,
            color: "primary.main",
          }}
        >
          {icono}
        </Box>
      )}
      <Box sx={{ minWidth: 0 }}>
        <Typography
          component="h1"
          variant={variante}
          sx={{ fontWeight: 700, color: "primary.main", overflowWrap: "anywhere" }}
        >
          {titulo}
        </Typography>
        {subtitulo && (
          <Typography variant="body2" sx={{ color: "text.secondary" }}>
            {subtitulo}
          </Typography>
        )}
      </Box>
    </Stack>

    {acciones && (
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: 1,
          justifyContent: { xs: "flex-start", sm: "flex-end" },
          alignItems: "center",
        }}
      >
        {acciones}
      </Box>
    )}
  </Stack>
);
